const NON_BREAKING_SPACE = '\u00a0'
const SKIPPED_TAGS = ['SCRIPT', 'STYLE', 'TEXTAREA', 'CODE', 'PRE']
const SHORT_WORDS = [
  'а', 'без', 'в', 'во', 'для', 'до', 'за', 'и', 'из', 'к', 'ко',
  'на', 'над', 'не', 'ни', 'но', 'о', 'об', 'обо', 'от', 'по',
  'под', 'при', 'про', 'с', 'со', 'у'
]
const SHORT_WORD_PATTERN = new RegExp(
  `(^|[\\s([{"«„])(${SHORT_WORDS.join('|')})[ \\t]+(?=[А-ЯЁа-яёA-Za-z0-9])`,
  'gi'
)

const addNonBreakingSpaces = text => text.replace(
  SHORT_WORD_PATTERN,
  `$1$2${NON_BREAKING_SPACE}`
)

const shouldSkipNode = node => {
  let element = node.parentElement

  while (element) {
    if (
      SKIPPED_TAGS.includes(element.tagName) ||
      element.isContentEditable ||
      element.hasAttribute('data-no-typography')
    ) {
      return true
    }

    element = element.parentElement
  }

  return false
}

const processTextNode = node => {
  if (!node.nodeValue || shouldSkipNode(node)) return

  const value = addNonBreakingSpaces(node.nodeValue)
  if (value !== node.nodeValue) node.nodeValue = value
}

const processNode = node => {
  if (node.nodeType === Node.TEXT_NODE) {
    processTextNode(node)
    return
  }

  if (node.nodeType !== Node.ELEMENT_NODE) return

  const walker = document.createTreeWalker(
    node,
    NodeFilter.SHOW_TEXT,
    null,
    false
  )

  let textNode = walker.nextNode()
  while (textNode) {
    processTextNode(textNode)
    textNode = walker.nextNode()
  }
}

const initTypography = root => {
  processNode(root)

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'characterData') {
        processTextNode(mutation.target)
        return
      }

      mutation.addedNodes.forEach(processNode)
    })
  })

  observer.observe(root, {
    childList: true,
    characterData: true,
    subtree: true
  })

  return () => observer.disconnect()
}

export { addNonBreakingSpaces, initTypography }
